import { Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthenticationService } from "src/app/services/authentication/authentication.service";
import Swal from "sweetalert2";
import { ChangePasswordComponent } from "../change-password/change-password.component";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DataSharingService } from "../../services/dataSharing/data-sharing.service";
@Component({
  selector: "app-recover-password",
  templateUrl: "./recover-password.component.html",
  styleUrls: ["./recover-password.component.css"],
})
export class RecoverPasswordComponent {
  loginForm: any;
  otpDiv = false;
  resendotpDiv = false;
  sendotpDiv = true;
  verifyotpDiv = false;
  submitted = false;
  postObj: any;
  constructor(
    private modalService: NgbModal,
    private AuthenticationService: AuthenticationService,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private dataService: DataSharingService
  ) {}
  ngOnInit(): void {
    this.loginForm = this.fb.group(
      {
        emailId: ["", [Validators.required]], //A.B.STEELTUBE.CUS00892
        otp: [""],
        user_id: [""],
        userType: [""],
      },
      {}
    );
  }
  get f() {
    return this.loginForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.loginForm.valid) {
      this.postObj = {
        username: this.loginForm.value.emailId,
        otp: this.loginForm.value.otp,
      };
      // console.log("form data", this.postObj);
      this.AuthenticationService.sendOTPForChangePassord(
        this.postObj
      ).subscribe((response: any) => {
        this.submitted = false;
        // console.log("response --- " + response);
        if (response.code == 1) {
          this.otpDiv = true;
          this.sendotpDiv = false;
          this.verifyotpDiv = true;
          this.resendotpDiv = true;
          var userType = response.data[0].userType;
          
          var user_id = response.data[0].user_id;

          this.loginForm.controls["userType"].setValue(userType);
          this.loginForm.controls["user_id"].setValue(user_id);
          // Swal.fire({
          //   title: "Success!",
          //   text: response.message,
          //   icon: "success",
          //   timer: 1000, // Time in milliseconds (e.g., 3000 ms = 3 seconds)
          //   // showConfirmButton: false, // Hide the "OK" button
          // });
        } else {
          Swal.fire({
            title: "Warning!",
            text: response.message,
            icon: "warning",
            timer: 3000,
          });
        }
      });
    } else {
      console.log("error");
    }
  }
  onVerifyOTP() {
    this.submitted = true;
    if (this.loginForm.valid) {
      this.postObj = {
        user_id: this.loginForm.value.user_id,
        userType: this.loginForm.value.userType,
        username: this.loginForm.value.emailId,
        otp: this.loginForm.value.otp,
      };
      // console.log("form data", this.postObj);
      this.AuthenticationService.verifyOTPForChangePassord(
        this.postObj
      ).subscribe((response: any) => {
        // console.log("response --- " + response);

        if (response.code == 1) {
          var userType = response.data[0].userType;
          var user_id = response.data[0].user_id;
          this.dataService.setUserType(userType);
          this.dataService.setId(user_id);
          Swal.fire({
            title: "Success!",
            text: response.message,
            icon: "success",
            timer: 1000, // Time in milliseconds (e.g., 3000 ms = 3 seconds)
            // showConfirmButton: false, // Hide the "OK" button
          });
          this.router.navigate(["/changePassword"]);
          // this.router.navigate(["/changePassword"]);
        } else {
          Swal.fire({
            title: "Warning!",
            text: response.message,
            icon: "warning",
            timer: 3000, // Time in milliseconds (e.g., 3000 ms = 3 seconds)
            // showConfirmButton: false, // Hide the "OK" button
          });
        }
      });
    } else {
      console.log("error");
    }
  }
  reSendotp() {}
  onCancel() {
    this.router.navigate(["/login"]);
  }
}
